import { Divider } from "@mui/material";
import type { ChangeEvent } from "react";
import { useIntl } from "react-intl";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { HOTEL_CLASSES } from "@/features/hotels/utils/constants";

type Props = {
  selectedClasses?: number[];
  userManuallySelectedAllClasses: boolean;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    option: number,
  ) => void;
};

export const HotelClassFilter = ({
  selectedClasses = [],
  userManuallySelectedAllClasses,
  onChange,
}: Props) => {
  const intl = useIntl();

  const areAllClassesSelected = selectedClasses.length === HOTEL_CLASSES.length;

  return (
    <ul>
      {HOTEL_CLASSES.map((option) => (
        <li key={option}>
          <label className="flex w-full items-center justify-between py-2">
            <span className="font-medium text-text-primary">
              {intl.formatMessage({ id: `hotels.filters.stars.${option}` })}
            </span>
            <Checkbox
              checked={
                selectedClasses?.includes(option) &&
                (userManuallySelectedAllClasses || !areAllClassesSelected)
              }
              onChange={(e) => onChange(e, e.target.checked, option)}
              density="compact"
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
